import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { blueColor } from 'js/config/style';

const size = '1.5rem';

export default styled(Icon).attrs({ name: 'question' })`
  display: inline-block;
  width: ${size};
  height: ${size};
  line-height: ${size};
  font-size: ${`${parseFloat(size) * 0.8}rem`};
  text-align: center;
  border-radius: 2rem;
  background: ${blueColor};
  color: white;
  margin-right: 0.5rem;
`;
